import { clinicCapabilitiesMapping } from '../agreementsConfig';
import {
    CHILD_CLINIC_HISTORY_KEY,
    CHILD_HISTORY_KEY,
    STORE_PROFILE_CHILD,
    USER_AGREEMENT_KEY,
    USER_CLINIC_HISTORY_KEY,
    USER_HISTORY_KEY
} from '../hooks/usePersonalData';
import {
    getCons,
    getUserRelatives
} from './getters';
import {
    getProviderCapabilities,
    getProviderCodes,
    getProviderCodesClinics
} from './providerCodes';
import { createSelector } from './utils';

export const getProviders = createSelector([ getCons ], consents => consents?.providers ?? {});

export const makeConsentObject = (cons = {}, providers = {}, addAllProviders = false) => {
    const providerList = cons?.providers ?? {};
    const cap = providers?.providerCapabilities ?? {};
    try {
        const {
            user = {},
            family = {},
            providerErrors = [],
            ...rest
        } = JSON.parse(JSON.stringify(cons ?? {}));
        const capabilities = Object.keys(clinicCapabilitiesMapping);
        const list = addAllProviders ? Array.from(new Set([...Object.keys(providerList), ...Object.keys(cap)])) : Object.keys(providerList)
            ?.filter
            ?.(p => !providerErrors?.includes?.(p));
        console.log('makeConsentObject', {list, addAllProviders, providerList, cap, capabilities});
        try {

            capabilities?.forEach(c => {
                list?.forEach(code => {
                    const u = user?.[code] ?? {};
                    const haveCapability = cap?.[code]?.includes(c);

                    if (haveCapability) {
                        return;
                    }

                    const uc = u?.[clinicCapabilitiesMapping[c].main];
                    if (uc === null || uc === undefined) {
                        if (addAllProviders) {
                            if (!user?.[code]) {
                                user[code] = {};
                            }
                            user[code][clinicCapabilitiesMapping[c].main] = true;
                        }
                    }

                    Object.keys(family)
                        ?.forEach(f => {
                            const mapping = clinicCapabilitiesMapping[c].family;
                            const fc = family?.[f]?.[code]?.[mapping];
                            if (fc === null || fc === undefined) {
                                if (addAllProviders) {
                                    if (!family?.[f]?.[code]) {
                                        family[f][code] = {};
                                    }
                                    family[f][code][mapping] = true;
                                }
                            }
                        });
                });
            });
        } catch (e) {
            console.log('!!!error capabilities', e);
        }
        providerErrors?.forEach?.((code) => {
            const consent = user?.[code];
            if (consent) {
                Object.keys(consent)
                    .forEach((key) => {
                        if (consent?.[key] === null) {
                            // console.log(`!!!change main user ${code} ${key} to false`);
                            user[code][key] = false;
                        }
                    });
            }
            Object.keys(family)
                ?.forEach((profile) => {
                    const profileUser = family?.[profile]?.[code];
                    if (profileUser) {
                        Object.keys(profileUser)
                            .forEach((key) => {
                                if (profileUser?.[key] === null) {
                                    // console.log(`!!!change user ${profile} ${code} ${key} to false`);
                                    family[profile][code][key] = false;
                                }
                            });
                    }
                });
        });
        console.log('make object consents finished', {
            ...cons,
            family,
            user,
            addAllProviders,
            ...rest,
        })
        return {
            ...cons,
            family,
            user,
            ...rest,
        };
    } catch (e) {
        console.log('error getConsents selector', {
            e,
            cons,
        });
        return cons;
    }
};

const getCardsProviderCodes = (cards = []) => cards
    ?.map?.((card) => card?.providerCode)
    ?.filter?.(Boolean) ?? [];

const profileConsentHasTrue = (consent = {}) =>
    Object.values(consent ?? {}).some((v) => v === true);

const profileConsentHasExplicitFalse = (consent = {}) =>
    Object.values(consent ?? {}).some((v) => v === false);

const pickConsentEntries = (consent = {}, predicate) =>
    Object.fromEntries(Object.entries(consent ?? {}).filter(([, v]) => predicate(v)));

/** Exported for DocumentsConsents (and tests): filter one profile slice by cards + explicit true/false clinic flags. */
export const filterProfileConsentsByCards = (profileConsents = {}, cards = []) => {
    const allowedProviders = new Set(getCardsProviderCodes(cards));
    return Object.entries(profileConsents ?? {})
        .reduce((acc, [ providerCode, consent ]) => {
            if (providerCode === 'main' || allowedProviders.has(providerCode)) {
                acc[providerCode] = consent;
                return acc;
            }
            if (profileConsentHasTrue(consent)) {
                acc[providerCode] = pickConsentEntries(consent, (v) => v === true);
                return acc;
            }
            return acc;
        }, {});
};

export const filterConsentsByCards = (consents = {}, userInfo = {}) => {
    try {
        const result = {
            ...consents,
            user: filterProfileConsentsByCards(consents?.user ?? {}, userInfo?.me?.cards ?? []),
            family: { ...(consents?.family ?? {}) },
        };

        const relatives = userInfo?.relatives ?? [];
        Object.keys(result.family)
            .forEach((profileId) => {
                const relative = relatives.find((entry) => `${entry?.profileId ?? ''}` === `${profileId ?? ''}`);
                const cards = relative?.cards ?? relative?.profile?.cards ?? [];
                result.family[profileId] = filterProfileConsentsByCards(result.family[profileId] ?? {}, cards);
            });
        return result;
    } catch (e) {
        console.log('error filterConsentsByCards selector', e);
        return consents;
    }
};

export const getConsents = createSelector([ getCons, getProviderCodes ], (cons, providers) => makeConsentObject(cons, providers));

export const getConsentsForAllProviders = createSelector([ getCons, getProviderCodes ], (cons, providers) => makeConsentObject(cons, providers, true));

const getUserProviders = user => {
    try {

        return Object.keys(user)
            ?.filter
            ?.(provider => provider !== 'main');
    } catch (e) {
        console.log('Error getUserProviders', e);
        return [];
    }
};

export const getConsentProviders = createSelector([ getConsents ], (consents) => {
    const res = getUserProviders(consents?.user);

    try {
        Object.keys(consents?.family)
            ?.forEach(profile => {
                const userProviders = getUserProviders(consents?.family?.[profile]);
                userProviders.forEach((provider) => {
                    if (!res.includes(provider)) {
                        res.push(provider);
                    }
                });
            });
    } catch (e) {
        console.log('Error getConsentProviders', e);
        //
    }
    return res;
});

export const getConsentClinics = createSelector([ getConsentProviders, getProviderCodesClinics ], (providers = [], clinics) => {
    return providers?.reduce?.((acc, p) => {
        const clinic = Object.values(clinics)
            ?.find
            ?.(({ providerCode }) => providerCode === p);
        return {
            ...acc,
            [p]: clinic,
        };
    }, {}) ?? {};

});

export const getClinics = createSelector([ getCons ], consent => consent?.providers);

export const getIsNeededConsentsReceived = createSelector(
    [ state => state?.consents, (_, params) => params ],
    ({
        profileId: userId,
        user,
        family,
    } = {}, {
        listAdult = [],
        listChild = [],
        profileId,
        provided,
        received,
    } = {}) => {
        if (received) {
            return true;
        }

        if (!profileId || !userId) {
            return false;
        }

        const isUser = userId === profileId;

        const providedSet = new Set();
        if (Array.isArray(provided)) {
            provided.forEach(p => providedSet.add(p));
        } else if (provided && typeof provided === 'object') {
            Object.keys(provided)
                .forEach((k) => {
                    if (provided[k]) {
                        providedSet.add(k);
                    }
                });
        }

        const requiredList = isUser ? listAdult : listChild;
        const required = requiredList.filter(k => !providedSet.has(k));
        if (required.length === 0) {
            return true;
        }
        const consents = isUser ? user : (family && family[profileId]) || {};
        return required.every(k => consents[k]);
    },
);

export const getIsConsentFailUpdateMode = createSelector([ getCons ], cons => cons?.failedUpdateMode === true);

export const getIsConsentsLoading = createSelector([ getCons ], c => c?.isLoading);


function isConsentValueValid(value) {
    return value === true || value === false;
}

export const getProviderErrors = createSelector([ getCons ], consents => consents?.providerErrors ?? []);

export const getConsentMainUser = createSelector([ getConsents ], consents => consents?.user);
export const getConsentMainUserCapabilities = createSelector([ getConsents, getProviderCapabilities ], (consents, capabilities) => {
    const keys = Object.keys(consents?.user);
    for (const key in keys) {
        const providerCode = keys[key];
        if (providerCode === 'main') {
            continue;
        }

        const capabilitiesList = Object.keys(clinicCapabilitiesMapping);
        const providerCapabilities = capabilities?.[providerCode] ?? [];
        capabilitiesList.forEach(c => {
            if (!providerCapabilities?.includes?.(c)) {
                const consentKey = clinicCapabilitiesMapping[c].main;
                if (consents?.user?.[providerCode]?.[consentKey] === null) {
                    if (!consents?.user?.[providerCode]) {
                        consents.user[providerCode] = {};
                    }
                    consents.user[providerCode][consentKey] = false;
                }
            }
        });
    }
    return consents?.user;
});

export const getConsentFamily = createSelector([ getConsents ], consents => consents?.family ?? {});
export const getConsentFamilyWithCapabilities = createSelector([ getConsentFamily, getProviderCapabilities ], (consents, capabilities) => {
    const providers = Object.keys(capabilities ?? {});
    const result = JSON.parse(JSON.stringify(consents ?? {}));
    for (const profileId in result) {
        const profile = result[profileId];
        for (const prov in profile) {
            if (providers.includes(prov)) {
                // console.log(`prov ${prov} has capabilities`, capabilities?.[prov]);
                const capabilitiesList = Object.keys(clinicCapabilitiesMapping);
                const providerCapabilities = capabilities?.[prov] ?? [];
                capabilitiesList.forEach(c => {
                    if (!providerCapabilities?.includes?.(c)) {
                        const consentKey = clinicCapabilitiesMapping[c].family;
                        if (result?.[profileId]?.[prov]?.[consentKey] === null) {
                            if (!result?.[profileId]?.[prov]) {
                                result[profileId][prov] = {};
                            }
                            result[profileId][prov][consentKey] = true;
                        }
                    }
                });
            }
        }
        // console.log('profileId', { profileId, prov: Object.keys(result[profileId]) });
    }
    // console.log('getConsentFamilyWithCapabilities', {consents, providers, capabilities, result});
    return result;
});

export const isProfileWithoutMainConsents = createSelector([ getConsentMainUserCapabilities ], (user) => {
    const neededConsents = [ USER_AGREEMENT_KEY, USER_HISTORY_KEY ];
    return neededConsents?.some?.(key => !isConsentValueValid(user?.main?.[key]));
});

export const isProfileWithoutClinicConsents = createSelector([ getConsentMainUserCapabilities, getProviderErrors ], (user, offline) => {
    const clinics = Object.keys(user)
        ?.filter(k => k !== 'main')
        ?.filter
        ?.(clinic => !offline?.includes?.(clinic)) ?? [];
    return clinics?.some?.(clinic => !isConsentValueValid(user?.[clinic]?.[USER_CLINIC_HISTORY_KEY]));
});

export const isProfileWithoutConsent = createSelector([ isProfileWithoutMainConsents, isProfileWithoutClinicConsents ], (main, clinic) => main || clinic);

export const isFamilyWithoutMainConsent = createSelector([ getConsentFamily ], (family) => {
    const users = Object.keys(family);
    const neededConsents = [ CHILD_HISTORY_KEY, STORE_PROFILE_CHILD ];
    const hasConsent = (obj) => {
        return neededConsents?.every?.(key => isConsentValueValid(obj?.main?.[key]));
    };
    return users?.some(user => !hasConsent(family?.[user]));
});

export const isFamilyWithoutClinicConsent = createSelector([ getConsentFamily ], (family) => {
    const users = Object.keys(family);
    const userClinics = (obj) => Object.keys(obj)
        .filter(k => k !== 'main');
    const hasConsent = (obj) => isConsentValueValid(obj?.[CHILD_CLINIC_HISTORY_KEY]);

    return users?.some((user) => {
        const obj = family?.[user] ?? {};
        const clinics = userClinics(obj);
        return !clinics?.every(clinic => hasConsent(obj?.[clinic]));
    });
});

export const isFamilyWithoutConsent = createSelector([ isFamilyWithoutMainConsent, isFamilyWithoutClinicConsent ], (main, clinic) => main || clinic);

export const getFamilyWithoutConsent = createSelector([ getConsentFamilyWithCapabilities,
    getProviderErrors,
    getUserRelatives ], (family, offline, relatives) => {
    const main = [];
    const clinic = [];
    const childs = relatives?.filter?.(({
        relKind,
        name,
        birthday,
        profileId,
    } = {}) => relKind === 'CHILD' && name && birthday && profileId)
        ?.map
        ?.(({ profileId }) => profileId) ?? [];
    const users = Object.keys(family)
        ?.filter(u => childs.includes(u));
    const neededConsents = [ CHILD_HISTORY_KEY, STORE_PROFILE_CHILD ];
    const hasMainConsent = (obj) => {
        return neededConsents?.every?.(key => isConsentValueValid(obj?.main?.[key]));
    };
    const userClinics = (obj) => Object?.keys(obj)
        .filter(k => k !== 'main')
        ?.filter
        ?.(k => !offline?.includes?.(k));

    users?.forEach((user) => {
        const obj = family?.[user] ?? {};
        if (!hasMainConsent(obj)) {
            main.push(user);
        } else {
            const clinics = userClinics(obj);
            if (!clinics?.every(clinic => isConsentValueValid(obj?.[clinic]?.[CHILD_CLINIC_HISTORY_KEY]))) {
                clinic.push(user);
            }
        }
    });

    return Array.from(new Set([ ...main, ...clinic ]));
});

export const getFamilyWithoutConsentObject = createSelector([ getConsentFamilyWithCapabilities,
    getFamilyWithoutConsent,
    getProviderErrors ], (family, list = [], offline) => {
    const result = {
        main: [],
        clinics: {},
    };
    if (!list?.length) {
        return result;
    }

    const neededConsents = [ CHILD_HISTORY_KEY, STORE_PROFILE_CHILD ];
    const userClinics = (obj) => Object?.keys(obj)
        .filter(k => k !== 'main')
        ?.filter
        ?.(k => !offline?.includes(k));

    const hasMainConsent = (obj) => {
        return neededConsents?.every?.(key => isConsentValueValid(obj?.main?.[key]));
    };

    list?.forEach((user) => {
        result.clinics[user] = [];
        const obj = family?.[user] ?? {};
        if (!hasMainConsent(obj)) {
            result.main.push(user);
        }
        const clinics = userClinics(obj);
        clinics?.forEach(clinic => {
            if (!isConsentValueValid(obj?.[clinic]?.[CHILD_CLINIC_HISTORY_KEY])) {
                result.clinics[user].push(clinic);
            }
        });
    });

    return result;
});
